import React, { useState, useEffect } from 'react';
import { shallowEqual, useSelector, useDispatch } from 'react-redux'
import { makeStyles } from '@material-ui/core/styles';
import moment from 'moment';

import { useHistory, useParams } from 'react-router-dom';

import TextField from '@material-ui/core/TextField';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import FormHelperText from '@material-ui/core/FormHelperText';
import FormControl from '@material-ui/core/FormControl';
import Select from '@material-ui/core/Select';
import CircularProgress from '@material-ui/core/CircularProgress';

import * as helpers from './helpers.js'
import * as globals from './globals.js'
import * as Actions from './redux-actions.js'


import Table from '@material-ui/core/Table';
import TableBody from '@material-ui/core/TableBody';
import TableCell from '@material-ui/core/TableCell';
import TableContainer from '@material-ui/core/TableContainer';
import TableHead from '@material-ui/core/TableHead';
import TablePagination from '@material-ui/core/TablePagination';
import TableRow from '@material-ui/core/TableRow';

import SyncIcon from '@material-ui/icons/Sync';
import EditIcon from '@material-ui/icons/Edit';
import IconButton from '@material-ui/core/IconButton';


import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogContentText from '@material-ui/core/DialogContentText';
import DialogTitle from '@material-ui/core/DialogTitle';


export const booking_columns = [
  { id: 'id', label: 'ID', minWidth: 30 },
  { id: 'create_time', label: 'Created', minWidth: 70,
    format: (value) => moment(value).format('DD.MM.YYYY HH:mm')
     },
  { id: 'booking_status', label: 'Status', minWidth: 140,
        format: (value) => {
              switch (value)  {
                case "CANCELED":
                  return (<b className="has-text-danger">{value}</b>)
                case "NOSHOWUP":
                  return (<b className="has-text-warning">{value}</b>)
                case "ACTIVE":
                  return (<b className="has-text-success">{value}</b>)
                default:
                  return (<b className="has-text-dark">{value}</b>)
              }
            }
     },
  {
    id: 'payment_option',
    label: 'Payment',
    minWidth: 70,
    align: 'right',
  },
  {
    id: 'payment_status',
    label: 'Pay. Status',
    minWidth: 100,
    align: 'right'
  },
  {
    id: 'client_name',
    label: 'Name',
    minWidth: 170,
    align: 'right'
  },
  {
    id: 'client_phone',
    label: 'Phone',
    minWidth: 100,
    align: 'right'
  },
  {
    id: 'client_email',
    label: 'Email',
    minWidth: 150,
    align: 'right'
  },
  {
    id: 'client_country',
    label: 'Country',
    minWidth: 100,
    align: 'right'
  },
  {
    id: 'special_notes',
    label: 'Notes',
    minWidth: 200,
  },
  {
    id: 'simcards',
    label: 'Simcards',
    minWidth: 200,
    format: (value) => { if (!value) return null
                         return value.map((v) => {
                            return (<div>{v.simcard} : {v.count}</div>)
                         })
                       }
  },
  {
    id: 'manual_price_calc',
    label: 'Manual price',
    minWidth: 100,
  },
  {
    id: 'price_updated',
    label: 'Price updated',
    minWidth: 100,
  },
  {
    id: 'price_azn',
    label: 'AZN',
    minWidth: 100,
  },
  {
    id: 'price_eur',
    label: 'EUR',
    minWidth: 80,
  },
];




const useStyles = makeStyles((theme) => ({
  root: {
      width: "100%",
  },
  container: {
    maxHeight: props => props.maxHeight || 550,
  },
}));



function Bookings(props) {
  const { p1 } = useParams()
  const classes = useStyles()
  const history = useHistory()
  const serverStatus = useSelector(state => state.serverStatus)
  const authenticated = useSelector(state => state.authenticated)
  const current_role = useSelector(state => state.current_role)
  const dispatch = useDispatch()
  const [loaded, setLoaded] = useState(false);
  const [userRoles, setUserRoles] = useState([]);
  const [apiCallInProgress, setApiCallInProgress] = useState(false);
  const [bookingdays, setBookingdays] = useState(60)
  const [data, setData] = useState([])
  const bookings = useSelector(state => state.db.bookings)
  const [refresh, setRefresh] = useState(true)
  const [bookid, setBookid] = useState(p1 ? p1 : null)

  let bookIdInputField


  useEffect(() => {
     
     if (authenticated && serverStatus) {
       setLoaded(false)
       console.log('DEBUG','GET BOOKINGS')
       helpers.getAPI(
         { func: (data, resp) => {
                 //setData(data)
                 dispatch({type: Actions.SET_BOOKINGS, value: data})
                 setLoaded(true)
            }, 
           uri: globals.myAPIurl+'/getdb?tab=bookings&days='+bookingdays
         })
     }


  }, [authenticated, bookingdays, refresh]);


  const refreshData = () => {
     setRefresh(!refresh)
  }

  if (! loaded) return (<div className="section has-background-light">
                          <CircularProgress />
                        </div>)
  
  let daysInputField

  let displayBookings = (bookid) ? bookings.filter((b)=>b.id===Number(bookid)) : bookings

  return (
  	<div>
     <div className="columns is-mobile">
       <div className="column is-10">
      <div class="field" style={{maxWidth: "3rem"}}>   
       <div class="control"> 
         <TextField
          id="bookings-days"
          label="Days"
          type="number"
          defaultValue={bookingdays}
          inputRef = {(c)=>daysInputField = c}
          onBlur={(e)=>{setBookingdays(daysInputField.value)}}
        />
      </div>
     </div>


    <div class="field" style={{maxWidth: "5rem"}}>   
       <div class="control"> 
         <TextField
          id="bookings-bookid"
          label="Booking ID"
          type="number"
          defaultValue={bookid}
          inputRef = {(c)=>bookIdInputField = c}
          onBlur={() => {setBookid(bookIdInputField.value)} }
        />
      </div>
     </div>



     </div>

     <div className="column is-2 has-text-right">
     
       <IconButton
        variant="contained"
        color="secondary"
        onClick={refreshData}>
          <SyncIcon />
       </IconButton>
      
      </div>
    </div>

    <BookingsTable data={displayBookings} editable={true}/>
    <div>Count: {displayBookings.length}</div>

    </div>
  )

}

export default Bookings



const useContentStyles = makeStyles((theme) => ({
  root: {
      overflowY: "initial",
  }
}));



export function BookingsTable (props) {
  const classes = useStyles()
  const containerClasses = useContentStyles()
  const dispatch = useDispatch()
  const history = useHistory()
  const [page, setPage] = React.useState(props.startPage || 0);
  const [rowsPerPage, setRowsPerPage] = React.useState(props.rowsPerPage || 10);
  const [open, setOpen] = React.useState(false);
  const [edit, setEdit] = React.useState({})

  let Rows = props.data
  let editValue
  let editValueObj = {}
  
  const editBooking = (id, booking_id, value) => {
    console.log('DEBUG', id, booking_id, value);
    setEdit({id, booking_id, value})
    setOpen(true);

  };



  const handleSave = () => {

    let changeValue = (editValue) ? editValue.value : undefined
    let changeValueObj = helpers.mapElementToValue(editValueObj)


    helpers.postAPI(
         { func: function(data) {
              //After receiving response from server
              if (data.status === 'OK') {
                
                dispatch({type: Actions.UPDATE_BOOKING, 
                          id: edit.booking_id,
                          column: edit.id,
                          value: (edit.id === "price_azn") ? changeValueObj : changeValue})

              } else {
                  helpers.closeMessage()
                  helpers.alertMessage('Error on server. '+data.message, globals.ERRO)
              }
          }, 
           uri: globals.myAPIurl+'/postdb',
           data: {what: "bookings",
                  id: edit.booking_id,
                  column: edit.id,
                  value: (edit.id === "price_azn") ? changeValueObj : changeValue}
         })

    setOpen(false);
  };


  const handleClose = () => {
    setOpen(false);
  };

  const handleChangePage = (event, newPage) => {
    setPage(newPage);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(+event.target.value);
    setPage(0);
  };

  return (
  <section>


      <Dialog open={open} onClose={handleClose} aria-labelledby="form-dialog-title">
        <DialogTitle id="form-dialog-title">
               {
                 (edit.id) && 
                   ( (edit.id === "price_azn") && "Price" || booking_columns.find((c)=>c.id===edit.id).label)
               }
        </DialogTitle>

        <DialogContent className={containerClasses.root}>

        {(edit.id && edit.id === "price_azn") && (
               <div className="columns">

                <div className="column">
                <div class="field" style={{maxWidth: "5rem"}}>   
                  <div class="control"> 
                    <TextField
                     id="bookings-price-azn"
                     label="AZN"
                     type="number"
                     defaultValue={edit.value.price_azn}
                     inputRef = {(c)=>editValueObj.azn = c}
                   />
                 </div>
                </div>
                </div>

                <div className="column">
                <div class="field" style={{maxWidth: "5rem"}}>   
                  <div class="control"> 
                    <TextField
                     id="bookings-price-eur"
                     label="EUR"
                     type="number"
                     defaultValue={edit.value.price_eur}
                     inputRef = {(c)=>editValueObj.eur = c}
                   />
                 </div>
                </div>
                </div>
              
              </div>

          ) ||

      
      ( <Select
          inputRef = {(c)=>editValue = c}
          defaultValue={edit.value}
          label="Value">

          {(edit.id && edit.id === "booking_status") && (
               
               ['ACTIVE','CANCELED','EXECUTED','NOSHOWUP'].map((v) => {
                   return <MenuItem value={v}>{v}</MenuItem>
               })

            )}

          {(edit.id && edit.id === "payment_status") && (
               
               ['CASH','NOTPAYED','PAYED'].map((v) => {
                   return <MenuItem value={v}>{v}</MenuItem>
               })

            )}
   
        </Select> )

        }

        </DialogContent>
        <DialogActions>
          <Button onClick={handleClose} color="primary">
            Cancel
          </Button>
          <Button onClick={handleSave} color="primary">
            Save
          </Button>
        </DialogActions>
      </Dialog>







     <TableContainer className={classes.container}>
        <Table stickyHeader aria-label="sticky table">
          <TableHead>
            <TableRow>
              {booking_columns.map((column) => (
                <TableCell
                  key={column.id}
                  align={column.align}
                  style={{ minWidth: column.minWidth }}
                >
                  {column.label}
                </TableCell>
              ))}
            </TableRow>
          </TableHead>
          <TableBody>
            {Rows.slice(page * rowsPerPage, page * rowsPerPage + rowsPerPage).map((row) => {
              return (
                <TableRow hover role="checkbox" tabIndex={-1} key={row.id}>
                  {booking_columns.map((column) => {
                    const value = row[column.id];
                    return (
                      
                      <TableCell key={column.id} align={column.align}>

                         { 
                            (column.id === "id") ? 
                                <Button color="primary" variant="outlined" onClick={() => history.push('/transfers/'+value)}>{value}</Button>
                            
                            : ( (column.format) ? column.format(value) : value )
                         }
                        
                         { 
                           ((column.id === "booking_status" || 
                             column.id === "payment_status" ||
                             column.id === "price_azn") && props.editable === true)
                               &&
                           (
                              <IconButton color="primary" component="span" size="small">
                                  <EditIcon fontSize="inherit" edge="end" onClick={(e) => editBooking(column.id, row.id, (column.id === "price_azn") ? row : value)}/>
                              </IconButton>
                           )
                         }


                      </TableCell>
                      
                    );
                  })}
                </TableRow>
              );
            })}
          </TableBody>
        </Table>
      </TableContainer>
      <TablePagination
        rowsPerPageOptions={[10, 25, 100]}
        component="div"
        count={Rows.length}
        rowsPerPage={rowsPerPage}
        page={page}
        onChangePage={handleChangePage}
        onChangeRowsPerPage={handleChangeRowsPerPage}
      />

   </section>


    )


}
